import { DealWorkflowStage } from "../models";

const createTempId = (): string => `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
// Generates a temporary ID for new deal workflow stages and key dates. This is necessary to manage them in the UI before they are saved to the backend and receive a permanent ID.

export const createDealWorkflowStageKeyDate = (name = ""): DealWorkflowStage["keyDates"][number] => ({
  id: createTempId(),
  name,
});

export const createDealWorkflowStage = (): DealWorkflowStage => ({
  description: "",
  id: createTempId(),
  keyDates: [createDealWorkflowStageKeyDate("start"), createDealWorkflowStageKeyDate("end")],
  name: "",
});
